var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutubeCircle = function SvgYoutubeCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#youtubeCircle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.476 4.476 0 10 0s10 4.476 10 10-4.476 10-10 10S0 15.524 0 10Zm14.771 3.924a1.475 1.475 0 0 0 1.048-1.048c.248-.933.248-2.867.248-2.867s.01-1.942-.248-2.876a1.475 1.475 0 0 0-1.048-1.047c-.933-.257-4.657-.257-4.657-.257s-3.724 0-4.657.247A1.504 1.504 0 0 0 4.41 7.133C4.162 8.067 4.162 10 4.162 10s0 1.943.248 2.867c.133.504.533.914 1.047 1.047.943.257 4.657.257 4.657.257s3.724 0 4.657-.247ZM12.03 10l-3.096 1.781V8.219L12.03 10Z",
    fill: "red"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "youtubeCircle_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  })))));
};
export default SvgYoutubeCircle;